import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  TextField,
  InputAdornment,
  IconButton,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

export default function SearchById({ collectionId }) {
  const navigate = useNavigate();
  const [searchId, setSearchId] = useState('');

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchId.trim()) {
      let formattedId = searchId.trim();
      
      // Check if the input already contains the collection prefix
      const hasPrefix = formattedId.toLowerCase().includes(collectionId.toLowerCase());

      // Collection-specific ID format mapping
      const idFormats = {
        // Current working collections
        'cool-cats': 'coolcat',
        'sappy-seals': 'sappy-seals',
        'sproto-gremlins': 'sproto-gremlins',
        'emby': 'emby',
        'meebits': 'meebits',
        'the-captainz': 'the-captainz',
        'cryptodickbutts-s3': 'cryptodickbutts',
        'creepz-by-overlord': 'creepz',
        'sugartown-oras': 'Sugartown Oras',
        'pixelady-maker': 'pixelady-maker',
        'quirkies-originals': 'quirkies',
        'infinigods': 'infinigods-community-pass',
        'xpsr-24': 'xpsr',
        'kanpai-pandas-infinity': 'kanpaipanda',
        'cyberkongz': 'cyberkongz',
        'a-kid-called-beast': 'beast',
        'proof-of-narnian-nft': 'narnian',
        'project-aeon': 'aeon',
        'boredapekennelclub': 'bakc',
        'degods': 'degods',
        'clonex': 'clonex',
        'mfer': 'mfers',
        'goblintown': 'goblintown',
        'checks-vv-originals': 'checks',
        'snackgang': 'snackgang',
        'metawinners': 'metawinners',
        'pirate-nation-founders': 'pirate-nation',
        '2049-reflections': '2049-reflections',
        'mushboomers': 'mushboomers',
        'digidaigaku': 'digidaigaku-genesis',
        'my-pet-hooligan': 'my-pet-hooligan',
        'moonbirds': 'moonbirds',
        'killabears': 'killabears',
        'radbro-webring': 'radbro-webring',
        'v1-cryptopunks-wrapped': 'v1-cryptopunks-wrapped',
        'khuga-by-khuga-labs': 'Khuga by Khuga Labs',
        'the-plague-nft': 'The Plague NFT',
        'rosentica-starfall-travelers': 'Starfall Travelers',
        'persona': 'Persona',
        'terraforms': 'terraforms',

          
        
        // Additional collections with prefixes
        'pirate-nation': 'pirate-nation',
        'opepen-edition': 'opepen',
        'async-blueprints': 'async-blueprints',
        'band-bears': 'band-bears',
        'bored-ape-kennel': 'bored-ape-kennel',
        'chimpers': 'chimpers',
        'clone-x': 'clone-x',
        'cyber-kongz': 'cyber-kongz',
        'digi-daigaku': 'digi-daigaku',
        'goblin-town': 'goblin-town',
        'honey-comb': 'honey-comb',
        'infini-gods': 'infini-gods',
        'kanpai-infinity': 'kanpai-infinity',
        'killa-bears': 'killa-bears',
        'moon-birds': 'moon-birds',
        'mush-boomers': 'mush-boomers',
        'nakamigos': 'nakamigos',
        'overworld-incarna': 'overworld-incarna',
        'potatoz': 'potatoz',
        'proof-of-narnian': 'proof-of-narnian',
        'radro-web-ring': 'radro-web-ring',
        'remilio-babies': 'remilio-babies',
        'snack-gang': 'snack-gang',
        'the-plague': 'the-plague',
        'the-plooshies': 'the-plooshies',
        'terraforms': 'terraforms',
        'v1-punks': 'v1-punks',
        'vv-checks': 'vv-checks'
      };

      // Collections that use numeric IDs only (no prefix needed)
      const numericCollections = [
        'pudgypenguins',
        'azuki',
        'doodles',
        'boredapeyachtclub',
        'mutant-ape-yacht-club',
        'beanz',
        'jirasan',
        'kanpai-pandas',
        'bit-bears',
        'mocaverse',
        'akidcalledbeast',
        'degods',
        'mfers',
        'mypethooligan',
        'reflections'
      ];

      // Handle collections with prefixed format
      if (idFormats[collectionId] && !hasPrefix) {
        formattedId = `${idFormats[collectionId]}-${formattedId}`;
      }
      // Handle collections that need numeric IDs
      else if (numericCollections.includes(collectionId) && !isNaN(formattedId)) {
        formattedId = parseInt(formattedId);
      }

      // Navigate to the item page
      navigate(`/collection/${collectionId}/item/${formattedId}`);
    }
  };

  return (
    <Box 
      component="form" 
      onSubmit={handleSearch}
      sx={{ 
        width: '100%',
        maxWidth: '200px',
      }}
    >
      <TextField
        fullWidth
        size="small"
        placeholder="Search by ID..."
        value={searchId}
        onChange={(e) => setSearchId(e.target.value)}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton 
                type="submit"
                size="small"
                sx={{ 
                  color: '#FF2E63',
                  padding: '4px',
                  '&:hover': {
                    backgroundColor: 'rgba(255, 46, 99, 0.1)'
                  }
                }}
              >
                <SearchIcon fontSize="small" />
              </IconButton>
            </InputAdornment>
          ),
          sx: {
            borderRadius: '50px',
            backgroundColor: 'rgba(26, 29, 36, 0.5)',
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: 'rgba(255, 46, 99, 0.2)',
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: '#FF2E63',
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: '#FF2E63',
            }
          }
        }}
      />
    </Box>
  );
}
